module.exports = "/images/Protection-3 Year.svg?1fa2bc6338e79987165ee983ea2e40ae";